module.exports = __webpack_public_path__ + "img/branch-particle-shadow-02.06753e2e.png";